import axios from "axios";
import {
  getNewCorrelationId,
  trackApiDependency,
  trackException,
} from "../components/utils/appInsights";

export const instance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_API_URL + "/api/",
  headers: {
    "Content-Type": "application/json",
  },
});

instance.interceptors.request.use(
  (config) => {
    const correlationId = getNewCorrelationId();

    config.headers = config.headers || {};
    config.headers["x-correlation-id"] = correlationId;
    config.metadata = {
      startedAt: Date.now(),
      correlationId,
    };

    return config;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (response) => {
    const metadata = response?.config?.metadata || {};
    const duration = Date.now() - (metadata.startedAt || Date.now());

    trackApiDependency({
      method: response?.config?.method,
      url: response?.config?.url,
      status: response?.status,
      duration,
      success: true,
      correlationId: metadata.correlationId,
    });

    return response;
  },
  (error) => {
    const metadata = error?.config?.metadata || {};
    const duration = Date.now() - (metadata.startedAt || Date.now());
    const requestUrl = error?.config?.url || "unknown_url";

    trackApiDependency({
      method: error?.config?.method,
      url: requestUrl,
      status: error?.response?.status,
      duration,
      success: false,
      correlationId: metadata.correlationId,
      properties: {
        errorCode: error?.code || "unknown_error",
      },
    });

    trackException(error, {
      source: "axios",
      url: requestUrl,
      method: (error?.config?.method || "get").toUpperCase(),
      status: String(error?.response?.status || 0),
      correlationId: metadata.correlationId,
    });

    return Promise.reject(error);
  }
);

export default instance;
